import { CART_COOKIE, CART_EXPIRY, ONE_YEAR_IN_SECONDS } from "@/config/cart";
import { getGoogleTokenForVariant } from "@/utils/googlePricing";
import { CartItem } from "@repo/core/cart";
import { setCookie } from "cookies-next";
import type { Product, Variant } from "types";

export type IncomingItem = {
  item: Variant;
  product?: Product;
  quantity: number;
};

export function prepareIncomingItem(incomingItem: IncomingItem) {
  const { item, quantity } = incomingItem;

  const googlePv2Token = getGoogleTokenForVariant(item.id);
  const variantAttributes = Object.keys(
    JSON.parse(item.VariantDefiningAttributes ?? "{}"),
  );

  const variant = variantAttributes
    ?.map((attribute) => item[attribute])
    .join(", ");

  return {
    quantity,
    partNo: item.id,
    vatRate: item.vatRate,
    googlePv2Token,
    extras: {
      product_url: item.link,
      stock_status: item.articleStatus,
      variant,
    },
  };
}

export function setCartCookie({ id, token }: { id: string; token: string }) {
  void setCookie(CART_COOKIE, `${id}:${token}`, {
    maxAge: ONE_YEAR_IN_SECONDS,
    expires: CART_EXPIRY,
  });
}

export function cartItemSkeleton(item?: Partial<CartItem>) {
  return {
    partNo: String(Math.random() * 100) + "abc",
    quantity: 1,
    brand: "",
    id: 0,
    imageKey: "",
    isDiscounted: false,
    lineNo: 0,
    name: "",
    price: 0,
    priceListId: 0,
    priceOriginal: 0,
    totalGrossAmount: 0,
    totalVat: 0,
    vatPerItem: 0,
    ...item,
  };
}
